export default "__VITE_ASSET__CRSxMTM5__"